// extracted by css-extract-rspack-plugin
export default {"cls1":"ProfileFeed-cls1_CPg","cls2":"ProfileFeed-cls2_PdE ProfileFeed-cls1_CPg"};